import { IVatReturnPeriodDetails } from '../../models';
import { formatDate, formatDateTime } from '../../../../utils/dates';

interface IVatReturnPeriodDetailsFormFields {
  vatReturnPeriodDetails_vatReturnPeriod: string | null;
  vatReturnPeriodDetails_vatReturnSubmissionDate: string | null;
  vatReturnPeriodDetails_vatReturnVersion: string | null;
  vatReturnPeriodDetails_year: number | null;
  vatReturnPeriodDetails_startDate?: Date | null;
  vatReturnPeriodDetails_endDate?: Date | null;
}

export default function handleVatReturnPeriodDetailsDefaultValues(
  vatReturnPeriodDetails: IVatReturnPeriodDetails
): IVatReturnPeriodDetailsFormFields {
  return {
    vatReturnPeriodDetails_vatReturnPeriod:
      vatReturnPeriodDetails.vat_return_period ?? null,
    vatReturnPeriodDetails_vatReturnSubmissionDate:
      formatDate(
        vatReturnPeriodDetails.vat_return_submission_date.toString()
      ) ?? null,
    vatReturnPeriodDetails_vatReturnVersion:
      vatReturnPeriodDetails.vat_return_version
        ? formatDateTime(vatReturnPeriodDetails.vat_return_version.toString()) ?? null
        : null,
    vatReturnPeriodDetails_year: vatReturnPeriodDetails.year ?? null,
    vatReturnPeriodDetails_startDate: vatReturnPeriodDetails.start_date ?? null,
    vatReturnPeriodDetails_endDate: vatReturnPeriodDetails.end_date ?? null,
  };
}
